import { combineReducers } from 'redux'

import listProducer from './listProducer'

export default combineReducers({
  listProducer: listProducer
})
